export interface CalcPerpPriceWithSlippageParams {
  isBuy: boolean;
  indexPrice: number;
  slippageFactor: number;
  priceIncrementDecimals: number;
}

export const calcPerpPriceWithSlippage = ({
  isBuy,
  slippageFactor,
  indexPrice,
  priceIncrementDecimals,
}: CalcPerpPriceWithSlippageParams): string => {
  const rawPriceWithSlippage = isBuy
    ? indexPrice * (1 + slippageFactor)
    : indexPrice * (1 - slippageFactor);
  const limitPriceWithSlippage = rawPriceWithSlippage.toFixed(
    priceIncrementDecimals,
  );

  return limitPriceWithSlippage;
};
